import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-delete-cell',
    templateUrl: './delete-cell.component.html',
    standalone: false
})
export class DeleteCellComponent implements ICellEditorAngularComp {
  agInit(): void {}
  getValue(): void {}
}
